import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { theme } from '@/styles';

export const IntroWrapper = styled.main`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const IntroText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  h1 {
    font-size: ${theme.fontSizes.lg};
    color: rgba(0, 0, 0, 0.7);
    font-family: 'Suit bold';
  }
  h3 {
    font-size: ${theme.fontSizes.md};
    color: rgba(0, 0, 0, 0.7);
    margin-bottom: 1vw;
    font-family: 'Suit bold', 'Inter bold';
  }
`;

export const LoadingSpinIcon = styled(LoadingOutlined)`
  font-size: 24px;
  color: black;
`;
